import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BACKEND_URL } from "../app.config";
import { TOKEN_KEY } from "../api/common/const";
import { FileWithContentDto } from "../api/document";
import { Document } from '../api/data-model';
import { Observable } from "rxjs";
import { RequestedDocument } from "../api/matter/matter-document-request";
@Injectable()
export class PublicService {
    constructor(
        private readonly http: HttpClient,
        @Inject(BACKEND_URL) private readonly baseUrl: string
    ) { }      

    getQuestionnaire(matterId: string, questionnaireId: string, applicantId: string) {
        const headers = this.getAuthHeader(matterId,questionnaireId);
        return this.http.get(`${this.baseUrl}/api/app/public/questionnaire/${questionnaireId}/${applicantId}`, { headers });
    }

    updateQuestionnaire(matterId: string, questionnaireId: string, applicantId: string, questionnaireJson: any) {
        const headers = this.getAuthHeader(matterId,questionnaireId);
        return this.http.put(`${this.baseUrl}/api/app/public/questionnaire/${questionnaireId}/${applicantId}`, questionnaireJson, { headers });
    }

    // getRequestedDocuments(matterId: string, questionnaireId: string) {
    //     const headers = this.getAuthHeader(matterId,questionnaireId);
    //     return this.http.get<RequestedDocument[]>(`${this.baseUrl}/api/app/public/documents`, { headers });
    // }

    // getDocumentDownloads(matterId: string, questionnaireId: string) {
    //     const headers = this.getAuthHeader(matterId,questionnaireId);
    //     return this.http.get<DocumentDownload[]>(`${this.baseUrl}/api/app/public/downloads`, { headers });
    // }

    getDocumentDownloadContent(matterId: string, questionnaireId: string, requestedDocId: string) {
        const headers = this.getAuthHeader(matterId,questionnaireId);
        return this.http.get<FileWithContentDto>(`${this.baseUrl}/api/app/public/downloads/${requestedDocId}`, { headers });
    }

    uploadDocuments(matterId: string, questionnaireId: string, requestedDocId: string, formData: FormData): Observable<Document[]> {
        const headers = this.getAuthHeader(matterId,questionnaireId);
        return this.http.post<Document[]>(this.baseUrl + `/api/app/public/documents/${requestedDocId}/upload`, formData, { headers });

    }

    addRequestedDocDocoments(matterId: string, questionnaireId: string, requestedDocId: string, applicantId: string, docs: string[]): Observable<RequestedDocument> {
        const headers = this.getAuthHeader(matterId,questionnaireId);
        return this.http.post<RequestedDocument>(`${this.baseUrl}/api/app/public/documents/${requestedDocId}/${questionnaireId}/${applicantId}`, docs, { headers });
    }

    deleteDocument(matterId: string, questionnaireId: string, requestedDocId: string, documentId: string, applicantId: string) {
        const headers = this.getAuthHeader(matterId,questionnaireId);
        return this.http.delete(`${this.baseUrl}/api/app/public/documents/${requestedDocId}/${documentId}/${questionnaireId}/${applicantId}`, { headers });
    }

    // deleteDocumentDownload(matterId: string, questionnaireId: string, documentId: string) {
    //     const headers = this.getAuthHeader(matterId,questionnaireId);
    //     return this.http.delete(`${this.baseUrl}/api/app/public/document-downloads/${matterId}/${questionnaireId}/${documentId}`, { headers });
    // }

    private getAuthHeader(matterId: string, questionnaireId: string): HttpHeaders {
        //const token = localStorage.getItem(TOKEN_KEY);
        const token = sessionStorage.getItem(TOKEN_KEY);
        console.log("Getting auth header with token:", token);
        return new HttpHeaders({
            'Skip-Error-Interceptor': 'true',
            'X-Authorization-Code': token || '',
            'X-Matter-Id': matterId,
            'X-Questionnaire-Id': questionnaireId
        });
    }
}
